<template>   
  <div v-if="showTrack">
    <Tracking :track="tracking" :firstName="firstName" :document="document" :showBack="showBack" @hiddenTrack="hiddenTrack" :account="account.code" :isOrder="true" :orderNumber="orderNumber" :parameters="parameters"></Tracking> 
  </div>
  <div style="margin-top: -70px;" v-else>  

    <!-- Modal Exportar -->
    <transition v-if="showModalExport" id="exportar" name="exportar">
      <div class="modal-cus-mask">
        <div class="modal-cus-wrapper">
          <div class="modal-cus-container" style="width:450px">

            <div class="modal-cus-header">
              <slot name="header">
                <div class="title-boreder">
                <div class="box-title box-title-sub">
                  <span>Exportar Reporte</span>
                </div>
                <button type="button" class="close" v-on:click="closeExport()" style="padding:5px;position: relative !important; top: -35px !important;" >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              </slot>
            </div>
            <div class="modal-cus-body" style="margin:10px">
              <slot name="body">
                <div class="row">
                  <p class="p-bus" style="text-align: left;padding-left: 20px;">
                    Indique su correo donde le llegará su reporte con el listado de pedidos:
                    <br/>
                    <br/>
                  </p>
                  <div class="col-md-12">
                    <div class="row">
                      <form @submit.prevent="exportOrder()" autocomplete="off">                    
                        <div class="col-lg-1 col-md-1 col-xs-2" style="    font-size: 24px; color: #3D77FF;">
                          <i class="fa fa-paper-plane a-icon" aria-hidden="true" ref="atrack"></i>
                        </div>
                        <div class="col-lg-8 col-md-8 col-xs-10 text-left">                                          
                            <div class="form-group">                  
                              <input v-model="fEmail" placeholder="Correo" class="form-control form-control-ora" :class="{ 'is-invalid': submitted && (!fEmail || !isEmail) }"/>
                              <div v-show="submitted && fEmail===''" class="invalid-feedback">El correo es requerido</div>
                              <div v-show="submitted && !isEmail" class="invalid-feedback">El correo es invalido</div>
                            </div>                        
                        </div>
                        <div class="col-lg-3 col-md-3 col-xs-12 text-center">
                          <button type="submit" v-bind:class="['btn btn-ora-blue', { 'disabled' : (submitted && (fEmail === '' || !isEmail)) }]">
                            Enviar
                          </button>
                        </div>
                      </form> 
                    </div>
                  </div>  
                </div>                
              
              </slot>
            </div>            
          </div>
        </div>
      </div>
    </transition>
    <!-- Fin Modal -->

    <!-- Modal Message -->
    <transition v-if="message.show" id="message" name="message">
      <div class="modal-cus-mask">
        <div class="modal-cus-wrapper">
          <div class="modal-cus-container" style="width:450px">

            <div class="modal-cus-header">
              <slot name="header">
                <div class="title-boreder">
                <div class="box-title box-title-sub">
                  <span>{{ message.title }}</span>
                </div>
                <button type="button" class="close" v-on:click="message.show = false" style="padding:5px;position: relative !important; top: -35px !important;" >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              </slot>
            </div>
            <div class="modal-cus-body" style="margin:10px">
              <slot name="body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-lg-1 col-md-1 col-xs-2" :class="{'msg-info': message.type === 'info', 'msg-warn': message.type === 'warn', 'msg-error': message.type === 'error'}">
                        <i :class="{'fa fa-info-circle a-icon': message.type === 'info', 'fa fa-exclamation-triangle a-icon': message.type === 'warn', 'fa fa-window-close a-icon': message.type === 'error'}" aria-hidden="true" ref="atrack"></i>
                      </div>
                      <div class="col-lg-8 col-md-8 col-xs-10 text-left">                                          
                          <div class="form-group">                  
                              {{ message.description }}
                          </div>                        
                      </div>
                      <div class="col-lg-3 col-md-3 col-xs-12 text-center">
                        <button type="button" class="btn btn-ora-msg" :class="{'btn-ora-msg-info': message.type === 'info', 'btn-ora-msg-warn': message.type === 'warn', 'btn-ora-msg-error': message.type === 'error'}" v-on:click="message.show = false">
                          Aceptar
                        </button>
                      </div>
                    </div>
                  </div>                  
                </div>
              </slot>
            </div>            
          </div>
        </div>
      </div>
    </transition>
    <!-- Fin Modal -->    
    
    <div style="margin: -15px !important;">        
      <div class="nav-order">
        <div class="ati-flex ati-header">          
          <img src="/static/img/svg/search.svg"/><span class="nav-header-title-label">Seguimiento de Pedido</span>
        </div>            
        <img :src="`data:image/png;base64,${order.accountLogo}`" style="height:35px" v-if="existe == 1 && order.accountLogo != null" />
      </div>  

      <div class="doc-filter" v-if="!mobile">
        <div class="ati-flex ati-pb">
          <div class="ati-flex">
            <div class="title-filter">
              <img src="/static/img/svg/doc-search.svg">
            </div>                  
            <span class="label-filter">Buscar Documento</span>
          </div>
          <div>           
            <button class="btn btn-sm btnAction btn-ora btn-ora-auto" style="width:120px;" v-on:click="showAdvanced()"> Avanzado</button>
          </div>
        </div>
        <div>
          <div class="filterContainer">
            <div class="row">
              <div class="col-xs-6 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-group">
                    <div class="input-group input-group-ora">
                      <div class="input-group-addon input-group-addon-ico">
                        <img src="/static/img/svg/calendar.svg" />
                      </div>
                      <input id="dtDateRange" name="dtDateRange" mode="text" placeholder="Fecha Pedido" class="form-control form-control-ora-sin" aria-labelledby="label-fecha" readOnly>
                      <label class="label-ora" for="dtDateRange" id="label-fecha">
                        <div class="text-ora">Fecha Pedido</div>
                      </label>                      
                    </div>
                  </div>                      
                </div>
              </div>
              <div class="col-xs-6 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="input-group input-group-ora">
                    <div class="input-group-addon input-group-addon-ico">
                      <img src="/static/img/svg/hash.svg" />
                    </div>
                    <input type="text" id="txtPedido" name="txtPedido" v-model="filter.CustomerOrderNumber" placeholder="Nro de Pedido" class="form-control form-control-ora-sin" maxlength="30" aria-labelledby="label-pedido">
                    <label class="label-ora" for="txtPedido" id="label-pedido">
                      <div class="text-ora">Nro de Pedido</div>
                    </label>                     
                  </div>
                </div>    
              </div>              
              <div class="col-xs-6 col-md-2 col-lg-2">
                <div class="form-group">  
                  <div class="input-group input-group-ora">
                    <div class="input-group-addon input-group-addon-ico" style="position: relative;">
                      <img src="/static/img/svg/layers.svg" />
                    </div>
                    <multiselect id="cboTipo" name="cboTipo" class="multiselect-ora multiselect-ora-layer"
                      v-model="filter.OrderType"
                      selectLabel=""
                      selectedLabel=""
                      deselectLabel=""                      
                      track-by="description"
                      label="description"
                      placeholder="Tipo"                      
                      :customLabel="optDescription"
                      :show-labels="false" 
                      :close-on-select="true"                    
                      :options="orderTypeList"
                      @open="reloadTypes()">
                      <span slot="noOptions">La lista esta vacia.</span>
                      <span slot="noResult">No se encontró el elemento buscado.</span>
                    </multiselect>
                    <label class="label-ora" for="cboTipo" id="label-tipo" >
                      <div class="text-ora">Tipo</div>
                    </label>                     
                  </div>                                                               
                </div>
              </div>
              <div class="col-xs-6 col-md-2 col-lg-2">
                <div class="form-group">  
                  <div class="input-group input-group-ora">
                    <div class="input-group-addon input-group-addon-ico" style="position: relative;">
                      <img src="/static/img/svg/zone.svg" />
                    </div>
                    <multiselect id="cboZona" name="cboZona" class="multiselect-ora multiselect-ora-point"
                      v-model="filter.Zone"
                      selectLabel=""
                      selectedLabel=""
                      deselectLabel=""
                      placeholder="Zona"
                      track-by="description"
                      label="description"
                      :customLabel="optDescription"
                      :show-labels="false" 
                      :close-on-select="true"                    
                      :options="orderZoneList"
                      @open="reloadZone()">
                      <span slot="noOptions">La lista esta vacia.</span> 
                      <span slot="noResult">No se encontró el elemento buscado.</span>
                    </multiselect>
                    <label class="label-ora" for="cboZona" id="label-zona" >
                      <div class="text-ora">Zona</div>
                    </label>                      
                  </div>                                                               
                </div>
              </div>
              <div class="col-xs-6 col-md-2 col-lg-2">
                <div class="form-group">  
                  <div class="input-group input-group-ora">
                    <div class="input-group-addon input-group-addon-ico" style="position: relative;">
                      <img src="/static/img/svg/bar.svg" />
                    </div>
                    <multiselect  id="cboEstado" name="cboEstado" class="multiselect-ora multiselect-ora-bar"
                      v-model="filter.Status"
                      selectLabel=""
                      selectedLabel=""
                      deselectLabel=""
                      placeholder="Estado"
                      track-by="description"
                      label="description"
                      :customLabel="optDescription"
                      :show-labels="false" 
                      :close-on-select="true"                    
                      :options="orderStatusList"
                      @open="reloadStatus()"> 
                      <span slot="noOptions">La lista esta vacia.</span>
                      <span slot="noResult">No se encontró el elemento buscado.</span>                                             
                    </multiselect>
                    <label class="label-ora" for="cboEstado" id="label-estado" >
                      <div class="text-ora">Estado</div>
                    </label>                       
                  </div>                                                               
                </div>
              </div>              
              <div class="col-xs-6 col-md-2 col-lg-2 text-right">
                <button class="btn btn-sm btnAction btn-ora btn-ora-auto" style="width:70px;" @click="clear()"> Limpiar</button>
                <button class="btn btn-sm btnAction btn-ora btn-ora-auto" style="width:70px;" @click="search(1)"> Buscar</button>
              </div>
            </div>  
            <transition name="fade">
              <div class="row" v-if="advanced">
                <div class="col-xs-6 col-md-2 col-lg-2">
                  <div class="form-group">
                    <div class="input-group input-group-ora">
                      <div class="input-group-addon input-group-addon-ico">
                        <img src="/static/img/svg/hash.svg" />
                      </div>
                      <input mode="text" id="txtTracking" name="txtTracking" v-model="filter.TrackingNumber" placeholder="Nro Tracking" class="form-control form-control-ora-sin" maxlength="20">
                      <label class="label-ora" for="txtTracking" id="label-tracking">
                      <div class="text-ora">Nro Tracking</div>
                    </label>                       
                    </div>
                  </div>
                </div>
                <div class="col-xs-6 col-md-2 col-lg-2">
                  <div class="form-group">
                    <div class="input-group input-group-ora">
                      <div class="input-group-addon input-group-addon-ico" style="position: relative;">
                        <img src="/static/img/svg/zone.svg" />
                      </div>
                      <multiselect id="cboDepartamento" name="cboDepartamento" class="multiselect-ora multiselect-ora-point"
                        v-model="filter.Department"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="Departamento"
                        track-by="name"
                        label="name"
                        :customLabel="optName"
                        :show-labels="false" 
                        :close-on-select="true"                    
                        :options="departamentList"
                        @input="getProvince()"
                        @open="reloadDepartament()">
                        <span slot="noOptions">La lista esta vacia.</span>
                        <span slot="noResult">No se encontró el elemento buscado.</span>
                      </multiselect>
                      <label class="label-ora" for="cboDepartamento" id="label-departamento" >
                        <div class="text-ora">Departamento</div>
                      </label>                        
                    </div>
                  </div>    
                </div>
                <div class="col-xs-6 col-md-2 col-lg-2">
                  <div class="form-group">
                    <div class="input-group input-group-ora">
                      <div class="input-group-addon input-group-addon-ico" style="position: relative;">
                        <img src="/static/img/svg/zone.svg" />
                      </div>
                      <multiselect id="cboProvincia" name="cboProvincia" class="multiselect-ora multiselect-ora-point"
                        v-model="filter.Province"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="Provincia"
                        track-by="name"
                        label="name"
                        :customLabel="optName"
                        :show-labels="false" 
                        :close-on-select="true"                    
                        :options="provinceList"
                        @input="getDistrict()"
                        @open="reloadProvince()">
                        <span slot="noOptions">La lista esta vacia.</span>
                        <span slot="noResult">No se encontró el elemento buscado.</span>
                      </multiselect>
                      <label class="label-ora" for="cboProvincia" id="label-provincia" >
                        <div class="text-ora">Provincia</div>
                      </label>                          
                    </div>
                  </div> 
                </div>
                <div class="col-xs-6 col-md-2 col-lg-2">
                  <div class="form-group">
                    <div class="input-group input-group-ora">
                      <div class="input-group-addon input-group-addon-ico" style="position: relative;">
                        <img src="/static/img/svg/zone.svg" />
                      </div>
                      <multiselect id="cboDistrito" name="cboDistrito" class="multiselect-ora multiselect-ora-point"
                        v-model="filter.District"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="Distrito"
                        track-by="name"
                        label="name"
                        :customLabel="optName"
                        :show-labels="false" 
                        :close-on-select="true"                    
                        :options="districtList"
                        @open="reloadDistrict()">
                        <span slot="noOptions">La lista esta vacia.</span>
                        <span slot="noResult">No se encontró el elemento buscado.</span>
                      </multiselect>
                      <label class="label-ora" for="cboDistrito" id="label-distrito" >
                        <div class="text-ora">Distrito</div>
                      </label>                       
                    </div>
                  </div> 
                </div>

                <div class="col-xs-6 col-md-4 col-lg-4 pull-center">
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>  
      
      <div v-else>
        <div class="filterContainer" style="padding-top: 20px;">
          <br/>
          <div class="row">
            <div class="col-xs-8" style="padding-right: 5px;">
              <div class="form-group">
                <div class="input-group input-group-ora">
                  <div class="input-group-addon input-group-addon-ico">
                    <img src="/static/img/svg/search-solid.svg" class="ico-seach-input" />
                  </div>
                  <input mode="text" v-model="filter.CustomerOrderNumber" id="txtPedido" name="txtPedido"  placeholder="Nro de Pedido" class="form-control form-control-ora-sin-blank"  maxlength="30">
                  <label class="label-ora" for="txtPedido" id="label-pedido" >
                    <div class="text-ora">Nro de Pedido</div>
                  </label>                  
                </div>
              </div>    
            </div>  
            <div class="col-xs-4 text-right"  style="padding-left: 0px;"> 
              <button class="btn btn-sm btnAction btn-ora btn-ora-auto" style="width:40px" @click="clear()"><img src="/static/img/svg/eraser.svg"></button>
              <button class="btn btn-sm btnAction btn-ora btn-ora-auto" style="width:40px" @click="search(1)"><img src="/static/img/svg/search-solid.svg"></button>
            </div>    
          </div>
          <div class="row">
            <div class="col-xs-4 text-left">
              <button class="btn btn-sm btnAction btn-ora btn-ora-auto" v-on:click="verFiltros()"><img src="/static/img/svg/filter.svg"><span style="padding-left:5px">Filtros</span></button>
            </div>
            <div class="col-xs-3 text-left"></div>
            <div class="col-xs-5 text-right">
                <button class="btn btn-sm btnAction btn-ora btn-ora-auto" v-on:click="showExport()"><img src="/static/img/svg/excel.svg"><span style="padding-left:5px">Exportar</span></button>
            </div>            
          </div>
          <br/>
          <div class="div-filtro" v-if="showFilter">
            <div class="row">            
              <div class="col-xs-12 text-right">
                <button class="btn btn-sm btnAction btn-ora btn-ora-auto" v-on:click="showAdvanced()"><img src="/static/img/svg/filter.svg"><span style="padding-left:5px">Búsqueda Avanzada</span></button>
              </div>
            </div>
            <br/>
            <div class="row"> 
              <div class="col-xs-12">
                <div class="form-group">
                  <div class="form-group">
                    <div class="input-group input-group-ora">
                      <div class="input-group-addon input-group-addon-ico">
                        <img src="/static/img/svg/calendar.svg" />
                      </div>
                      <input id="dtDateRange" name="dtDateRange" placeholder="Fecha Pedido" mode="text" class="form-control form-control-ora-sin" readOnly>
                      <label class="label-ora" for="dtDateRange" id="label-fecha">
                        <div class="text-ora">Fecha Pedido</div>
                      </label>                        
                    </div>
                  </div>                      
                </div>
              </div>
              <div class="col-xs-12">
                <div class="form-group">  
                  <div class="input-group input-group-ora">
                    <div class="input-group-addon input-group-addon-ico" style="position: relative;">
                      <img src="/static/img/svg/layers.svg" />
                    </div>
                    <multiselect id="cboTipo" name="cboTipo" class="multiselect-ora multiselect-ora-layer"
                      v-model="filter.OrderType"
                      selectLabel=""
                      selectedLabel=""
                      deselectLabel=""
                      placeholder="Tipo"
                      track-by="description"
                      label="description"
                      :customLabel="optDescription"
                      :show-labels="false" 
                      :close-on-select="true"                    
                      :options="orderTypeList"
                      @open="reloadTypes()">
                      <span slot="noOptions">La lista esta vacia.</span>
                      <span slot="noResult">No se encontró el elemento buscado.</span>
                    </multiselect>
                    <label class="label-ora" for="cboTipo" id="label-tipo">
                      <div class="text-ora">Tipo</div>
                    </label>                    
                  </div>                                                               
                </div>
              </div>
              <div class="col-xs-12">
                <div class="form-group">  
                  <div class="input-group input-group-ora">
                    <div class="input-group-addon input-group-addon-ico" style="position: relative;">
                      <img src="/static/img/svg/zone.svg" />
                    </div>
                    <multiselect id="cboZona" name="cboZona" class="multiselect-ora multiselect-ora-point"
                      v-model="filter.Zone"
                      selectLabel=""
                      selectedLabel=""
                      deselectLabel=""
                      placeholder="Zona"
                      track-by="description"
                      label="description"
                      :customLabel="optDescription"
                      :show-labels="false" 
                      :close-on-select="true"                    
                      :options="orderZoneList"
                      @open="reloadZone()"> 
                      <span slot="noOptions">La lista esta vacia.</span>
                      <span slot="noResult">No se encontró el elemento buscado.</span>
                    </multiselect>
                    <label class="label-ora" for="cboZona" id="label-zona">
                      <div class="text-ora">Zona</div>
                    </label>                     
                  </div>                                                               
                </div>
              </div>
              <div class="col-xs-12">
                <div class="form-group">  
                  <div class="input-group input-group-ora">
                    <div class="input-group-addon input-group-addon-ico" style="position: relative;">
                      <img src="/static/img/svg/bar.svg" />
                    </div>
                    <multiselect id="cboEstado" name="cboEstado" class="multiselect-ora multiselect-ora-bar"
                      v-model="filter.Status"
                      selectLabel=""
                      selectedLabel=""
                      deselectLabel=""
                      placeholder="Estado"
                      track-by="description"
                      label="description"
                      :customLabel="optDescription"
                      :show-labels="false" 
                      :close-on-select="true"                    
                      :options="orderStatusList"
                      @open="reloadStatus()">
                      <span slot="noOptions">La lista esta vacia.</span>
                      <span slot="noResult">No se encontró el elemento buscado.</span>
                    </multiselect>
                    <label class="label-ora" for="cboEstado" id="label-estado">
                      <div class="text-ora">Estado</div>
                    </label>                        
                  </div>                                                               
                </div>
              </div> 

              <div v-if="advanced">                
                <div class="col-xs-12">
                  <div class="form-group">
                    <div class="input-group input-group-ora">
                      <div class="input-group-addon input-group-addon-ico">
                        <img src="/static/img/svg/hash.svg" />
                      </div>
                      <input mode="text" id="txtTacking" name="txtTacking" v-model="filter.TrackingNumber" placeholder="Nro Tracking" class="form-control form-control-ora-sin"  maxlength="20">
                      <label class="label-ora" for="txtTacking" id="label-tracking">
                        <div class="text-ora">Nro Tracking</div>
                      </label>                       
                    </div>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="form-group">
                    <div class="input-group input-group-ora">
                      <div class="input-group-addon input-group-addon-ico" style="position: relative;">
                        <img src="/static/img/svg/zone.svg" />
                      </div>
                      <multiselect id="cboDepartamento" name="cboDepartamento" class="multiselect-ora multiselect-ora-point"
                        v-model="filter.Department"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="Departamento"
                        track-by="name"
                        label="name"
                        :customLabel="optName"
                        :show-labels="false" 
                        :close-on-select="true"                    
                        :options="departamentList"
                        @input="getProvince()"
                        @open="reloadDepartament()">
                        <span slot="noOptions">La lista esta vacia.</span>
                        <span slot="noResult">No se encontró el elemento buscado.</span>
                      </multiselect>
                      <label class="label-ora" for="cboDepartamento" id="label-departamento">
                        <div class="text-ora">Departamento</div>
                      </label>                       
                    </div>
                  </div>    
                </div>
                <div class="col-xs-12">
                  <div class="form-group">
                    <div class="input-group input-group-ora">
                      <div class="input-group-addon input-group-addon-ico" style="position: relative;">
                        <img src="/static/img/svg/zone.svg" />
                      </div>
                      <multiselect id="cboProvincia" name="cboProvincia" class="multiselect-ora multiselect-ora-point"
                        v-model="filter.Province"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="Provincia"
                        track-by="name"
                        label="name"
                        :customLabel="optName"
                        :show-labels="false" 
                        :close-on-select="true"                    
                        :options="provinceList"
                        @input="getDistrict()"
                        @open="reloadProvince()">
                        <span slot="noOptions">La lista esta vacia.</span>
                        <span slot="noResult">No se encontró el elemento buscado.</span>
                      </multiselect>
                      <label class="label-ora" for="cboProvincia" id="label-provincia">
                        <div class="text-ora">Provincia</div>
                      </label>                       
                    </div>
                  </div> 
                </div>
                <div class="col-xs-12">
                  <div class="form-group">
                    <div class="input-group input-group-ora">
                      <div class="input-group-addon input-group-addon-ico" style="position: relative;">
                        <img src="/static/img/svg/zone.svg" />
                      </div>
                      <multiselect id="cboDistrito" name="cboDistrito" class="multiselect-ora multiselect-ora-point"
                        v-model="filter.District"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="Distrito"
                        track-by="name"
                        label="name"
                        :customLabel="optName"
                        :show-labels="false" 
                        :close-on-select="true"                    
                        :options="districtList"
                        @open="reloadDistrict()">
                        <span slot="noOptions">La lista esta vacia.</span>
                        <span slot="noResult">No se encontró el elemento buscado.</span>
                      </multiselect>
                      <label class="label-ora" for="cboDistrito" id="label-distrito">
                        <div class="text-ora">Distrito</div>
                      </label>                      
                    </div>
                  </div> 
                </div>               
              </div>              
              <div class="col-xs-12 text-center">
                <button class="btn btn-sm btnAction btn-ora btn-ora-auto" @click="clear()"> Limpiar</button>
                <button class="btn btn-sm btnAction btn-ora btn-ora-auto" @click="search(1)"> Buscar</button>
              </div>            
            </div>
          </div>
        </div>
      </div>
      
      
      <div class="doc-filter" v-if="!mobile">
        <div class="ati-flex ati-pb">
          <div class="ati-flex">
            <div class="title-filter">
              <img src="/static/img/svg/list.svg">
            </div>                  
            <span class="label-filter">Pedidos</span>
          </div>
          <div>           
            <button class="btn btn-sm btnAction btn-ora btn-ora-auto" v-on:click="showExport()"><img src="/static/img/svg/excel.svg"><span style="padding-left:5px">Exportar</span></button>
          </div>
        </div>
        <div>
          <div class="filterContainer">
            <vuetable 
              id="resultTable"
              ref="vuetable"
              :api-mode="false"
              :fields="tableFields"
              :css="tableCSS.table"
              noDataTemplate="No se encontraron resultados"
              :data="tableData"
              :data-manager="dataManager"
              pagination-path="pagination"
              @vuetable:pagination-data="onPaginationData"
              :key="tableKey">
              <!--
              <template slot="orderTypeCode" scope="props">
                <div class="text-center" :class="{'selected-row': selectIndex === props.rowIndex}">
                  <img :src="props.rowData.orderTypeCode === 'DEV' ? '/static/img/svg/return.svg' : '/static/img/svg/delivery.svg'" style="width: 24px;" :class="{ 'data-type': props.rowData.orderTypeCode === 'ENT' ? true : false, 'data-type-orange': props.rowData.orderTypeCode === 'DEV' ? true : false }" />                      
                </div>
              </template>
              -->
              <template slot="orderType" scope="props">
                <div>
                  <span >{{props.rowData.orderType | firstLetter}}</span>
                </div>
              </template>
              <template slot="orderNumber" scope="props">
                <div style="min-width: 100px;">
                  <span >{{ props.rowData.customerOrderNumber }}</span>
                </div>
              </template>
              <template slot="issueDate" scope="props">
                <div style="min-width: 120px; text-align: center;">
                  <span>{{props.rowData.issueDate | formatDateOnly("DD/MM/YYYY",true)}}</span>
                </div>
              </template>
              <template slot="customerName" scope="props">
                <div>
                  <span >{{props.rowData.customerName | firstLetter}}</span>
                </div>
              </template>
              <template slot="customerAddress" scope="props">
                <div>
                  <span >{{props.rowData.customerAddress | firstLetter}}</span>
                </div>
              </template>              
              <template slot="status" scope="props">
                <div class="data-status-ora">
                  {{ props.rowData.status | firstLetter }}
                </div>
              </template>                               
              <template slot="trackingNumber" scope="props">
                <div :class="{'selected-row': selectIndex === props.rowIndex}">
                  <a class="data-arrow" data-toggle="collapse" v-on:click="goTracking(props.rowData, props.rowIndex)"><i class="fa fa-chevron-right" aria-hidden="true"></i></a>
                </div>                
              </template>
            </vuetable>                

            <div class="row">
              <div class="col-md-6">                
                &nbsp;
                <template v-if="this.paginationData && paginationData.total > 0">
                  <strong style="color: #364A5D; paddin-left:15px;">
                  Mostrando documento {{ this.paginationData.from > 1 ? this.paginationData.from : this.paginationData.from + (pageNumber - 1 ) * 20 }} a {{ this.paginationData.to < this.paginationData.per_page ? this.paginationData.total : this.paginationData.to * this.pageNumber }} de {{ this.paginationData.total }} en Total
                  </strong>
                </template>
              </div>
              <div class="col-md-6">
                <vuetable-pagination ref="pagination"
                  :css="tableCSS.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </div>            
          </div>

        </div>
      </div>

      <div v-else style="padding: 20px 5px 20px 5px;">
        <div class="ati-flex ati-pb">
          <div class="ati-flex">
            <div class="title-filter">
              <img src="/static/img/svg/list.svg">
            </div>                  
            <span class="label-filter">Pedidos</span>
          </div>         
        </div>
        <div>
          <div class="filterContainer">
            <div v-if="tableData.data === null || tableData.data.length === 0" style="text-align: center;">No se encontraron resultados</div>
            <div v-for="(order, index) in tableData.data" :key="index" ref="detailsitem" class="div-data" :class="{'selected-row-mov': selectIndex === index}">
              <!--
              <div class="div-data-ico">
                <div class="div-data-ico-circle" @click="goTracking(order, index)">
                  <img :src="order.orderTypeCode === 'DEV' ? '/static/img/svg/return.svg' : '/static/img/svg/delivery.svg'" :class="{ 'div-data-ico-img data-type': order.orderTypeCode === 'ENT' ? true : false, 'div-data-ico-img data-type-orange': order.orderTypeCode === 'DEV' ? true : false }" />                      
                </div>
              </div> 
              -->              
              <div class="row" @click="goTracking(order, index)">               
                <div class="col-xs-4 div-data-space">
                  <div class="form-group div-data-bottom">
                    <label class="div-data-title">Tipo</label>
                    <br/>
                    <span class="div-data-value">{{ order.orderType | firstLetter }}</span>
                  </div>              
                </div>
                <div class="col-xs-4 div-data-space">
                  <div class="form-group div-data-bottom">
                    <label class="div-data-title">Nro. Pedido</label>
                    <br/>
                    <span class="div-data-value-limit">{{ order.customerOrderNumber }}</span>
                  </div>              
                </div>
                <div class="col-xs-4 div-data-space">
                  <div class="form-group div-data-bottom">
                    <label class="div-data-title">Fecha Pedido</label>
                    <br/>
                    <span class="div-data-value">{{ order.issueDate | formatDate("DD/MM/YYYY",true) }}</span>
                  </div>              
                </div>
                <div class="col-xs-12 div-data-space">
                  <div class="form-group div-data-bottom">
                    <label class="div-data-title">Nombre del Cliente</label>
                    <br/>
                    <span class="div-data-value">{{ order.customerName | firstLetter }}</span>
                  </div>              
                </div>  
                <div class="col-xs-12 div-data-space">
                  <div class="form-group div-data-bottom">
                    <label class="div-data-title">Dirección</label>
                    <br/>
                    <span class="div-data-value">{{ order.customerAddress | firstLetter }}</span>
                  </div>              
                </div>   
                <div class="col-xs-12 div-data-space">
                  <div class="form-group div-data-bottom">
                    <label class="div-data-title">Status</label>
                    <br/>
                    <span class="div-data-status" style="color:#3D77FF">{{ order.status | firstLetter }}</span>
                  </div>              
                </div>                                                                             
              </div>            
            </div>
            <div class="row">
              <div class="col-xs-12 text-center">
                <vuetable ref="vuetable" style="display:none"
                  :api-mode="false"  
                  :fields="tableFields"                                        
                  :data="tableData"
                  :data-manager="dataManager"
                  pagination-path="pagination"
                  @vuetable:pagination-data="onPaginationData"
                  :key="tableKey">
                </vuetable>                
                <template v-if="this.paginationData && paginationData.total > 0">
                  <strong style="color: #364A5D; paddin-left:15px;">
                    Mostrando documento {{ this.paginationData.from > 1 ? this.paginationData.from : this.paginationData.from + (pageNumber - 1 ) * 20 }} a {{ this.paginationData.to < this.paginationData.per_page ? this.paginationData.total : this.paginationData.to * this.pageNumber }} de {{ this.paginationData.total }} en Total
                  </strong>
                </template>
              </div>
              <div class="col-xs-12 text-center">
                <vuetable-pagination ref="pagination" style="float:none !important"
                  :css="tableCSS.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </div>            
          </div>
        </div>
      </div>
      <div class="msg-order" v-if="existe == 0">
        <div v-if="mobile">
          <img src="/static/img/noencontrado.png" class="img-nf" />
        </div>        
        <div>
          <div class="title-nf">
            No hemos podido encontrar tu pedido
          </div>
          <p class="p-nf">
            Comunicate con nosotros para brindarte información de tu pedido
          </p>
          <br/>
          <button v-on:click="contact()" class="btn btn-ora" style="width:200px">Contáctate con nosotros</button>
        </div>
        <div v-if="!mobile">
          <img src="/static/img/noencontrado.png" class="img-nf" />
        </div>
      </div>             
    </div>       
  </div>           
</template>
  <script>
    import { mapGetters, mapActions } from 'vuex'
    import constants from 'assets/js/constants.js'
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'
    import 'bootstrap-daterangepicker/daterangepicker.css'
    import 'bootstrap-daterangepicker/daterangepicker.js'
    import moment from 'moment/moment.js'
    import { Vuetable, VuetablePagination } from 'vuetable-2'

    export default {
      name: 'OrderSearch',
      data () {
        return {
          loader: null,
          mobile: false,
          existe: -1,
          advanced: false,
          showFilter: false,
          parameters: {},
          defualtFilter: false,
          selectIndex: -1,
          defaultSelect: {key: '', description: '-- Todos --'},
          defaultUbigeo: {code: '', name: '-- Todos --'},
          dateRange: null,
          orderTypeList: [],
          orderZoneList: [],
          orderStatusList: [],
          departamentList: [],
          provinceList: [],
          districtList: [],
          accountList: [],
          account: {},
          firstName: '',
          document: '',
          tracking: '',
          showTrack: false,
          showBack: false,
          showModalExport: false,
          fEmail: '',
          isEmail: true,
          submitted: false,
          filter: {
            AccountCode: '',
            CustomerOrderNumber: '',
            TrackingNumber: '',
            StartOrderDate: '',
            EndOrderDate: '',
            OrderType: null,
            Zone: null,
            Status: null,
            Department: null,
            Province: null,
            District: null,
            Page: 1,
            PageSize: 20
          },
          message: {
            title: '',
            description: '',
            type: '',
            show: false
          },
          order: {},
          window: {
            width: 0,
            height: 0
          },
          tableKey: 1,
          tableData: {
            data: null
          },
          totalPages: 0,
          pageNumber: 1,
          tableFields: [
            {
              name: '__slot:orderType',
              title: 'Tipo',
              titleClass: 'table-text-ora',
              dataClass: 'table-data-ora'
            },
            {
              name: '__slot:orderNumber',
              title: 'Nro de Pedido',
              titleClass: 'table-text-ora',
              dataClass: 'table-data-ora'
            },
            {
              name: '__slot:issueDate',
              title: 'Fecha de Pedido',
              callback: 'formatDate',
              titleClass: 'table-text-ora',
              dataClass: 'table-data-ora'
            },
            {
              name: '__slot:customerName',
              title: 'Nombre del Cliente',
              titleClass: 'table-text-ora',
              dataClass: 'table-data-ora'
            },
            {
              name: '__slot:customerAddress',
              title: 'Dirección',
              titleClass: 'table-text-ora',
              dataClass: 'table-data-ora'
            },
            {
              name: '__slot:status',
              title: 'Status',
              titleClass: 'table-text-ora',
              dataClass: 'table-data-ora'
            },
            {
              name: '__slot:trackingNumber',
              title: '',
              titleClass: 'table-text-ora',
              dataClass: 'table-data-ora'
            }
          ],
          tableCSS: null,
          tableOptions: {
            filterable: false,
            texts: {
              count: ''
            }
          },
          paginationData: null
        }
      },
      mounted () {
        if (this.$route.params.Index === undefined) {
          this.iniCalendar()
        }
      },
      computed: {
        ...mapGetters([
          'userClients'
        ])
      },
      async created () {
        this.accountList = Array.from(this.userClients)
        this.account = this.accountList.length > 0 ? this.accountList[0] : null
        this.tableCSS = constants.tableCSSOra
        this.mobile = this.isMobile()

        if (this.$route.params.Index === undefined) {
          this.loadSelectData()
        } else {
          this.defualtFilter = true
          this.parameters = this.$route.params
          this.filter.AccountCode = this.parameters.AccountCode
          this.filter.CustomerOrderNumber = this.parameters.CustomerOrderNumber
          this.filter.TrackingNumber = this.parameters.TrackingNumber

          await this.getTypes(this.parameters.OrderType)
          await this.getZones(this.parameters.Zone)
          await this.getStatus(this.parameters.Status)

          this.filter.Department = this.parameters.Department
          this.filter.Province = this.parameters.Province
          this.filter.District = this.parameters.District
          this.selectIndex = this.parameters.Index

          this.advanced = false
          let calen = false
          if (this.mobile) {
            if (this.parameters.StartOrderDate !== null || this.parameters.EndOrderDate !== null || this.parameters.OrderType !== null || this.parameters.CustomerOrderNumber !== '' || this.parameters.Zone !== null) {
              if (this.parameters.StartOrderDate !== null || this.parameters.EndOrderDate !== null) {
                calen = true
              }
              this.showFilter = true
            }
          } else {
            calen = true
          }

          if (calen) {
            let self = this

            setTimeout(async function () {
              self.iniCalendar()
              if (self.parameters.StartOrderDate !== null && self.parameters.EndOrderDate !== null) {
                $(self.$el).find('#dtDateRange').data('daterangepicker').startDate = moment(self.parameters.StartOrderDate)
                $(self.$el).find('#dtDateRange').data('daterangepicker').endDate = moment(self.parameters.EndOrderDate)
                let date = $(self.$el).find('#dtDateRange').data('daterangepicker')
                $('#dtDateRange').val(date.startDate.format('DD/MM/YYYY') + ' - ' + date.endDate.format('DD/MM/YYYY'))
              }
              await self.getDePrDi(self.parameters.Department, self.parameters.Province, self.parameters.District)
              if (self.parameters.Department !== null || self.parameters.Province !== null || self.parameters.District !== null || self.parameters.TrackingNumber !== '') {
                if (self.parameters.Department.code !== '' || self.parameters.Department.code !== '' || self.parameters.Department.code !== '' || self.parameters.TrackingNumber !== '') {
                  self.advanced = true
                }
              }

              let scrollY = self.parameters.ScrollY
              await self.search(self.parameters.Page, false, false)
              setTimeout(function () {
                $(window).scrollTop(scrollY)
              }, 1000)
              // window.scrollTo({ top: 500, behavior: 'smooth' })
              // window.scrollTo(0, scrollY)
              // window.pageYOffset === self.parameters.scrollY
            }, 1000)
          } else {
            let self = this
            self.iniCalendar()
            await self.getDePrDi(self.parameters.Department, self.parameters.Province, self.parameters.District)
            let scrollY = self.parameters.ScrollY
            await self.search(self.parameters.Page, false, false)
            setTimeout(function () {
              $(window).scrollTop(scrollY)
            }, 1000)
          }
        }

        window.onpopstate = () => {
          history.go(1)
        }
      },
      methods: {
        ...mapActions([
          'getOrderType',
          'getOrderZone',
          'getOrderStatus',
          'getUbigeo',
          'getOrderFollow',
          'getOrderReport'
        ]),
        isMobile () {
          if (screen.width <= 760) {
            return true
          } else {
            return false
          }
        },
        loadSelectData () {
          this.getTypes()
          this.getZones()
          this.getStatus()
          this.getDepartament()
        },
        getTypes (type = null) {
          this.orderTypeList.push(this.defaultSelect)
          return this.getOrderType().then((response) => {
            if (response === undefined) {
              if (type !== null) {
                this.orderTypeList.push(type)
              }
            } else {
              this.orderTypeList = this.orderTypeList.concat(response.typeList)
            }
            this.filter.OrderType = type === null ? this.defaultSelect : this.orderTypeList.find(x => x.key === type.key)
          })
        },
        getZones (zone = null) {
          this.orderZoneList.push(this.defaultSelect)
          return this.getOrderZone().then((response) => {
            if (response === undefined) {
              if (zone !== null) {
                this.orderZoneList.push(zone)
              }
            } else {
              this.orderZoneList = this.orderZoneList.concat(response.zoneList)
            }
            this.filter.Zone = zone === null ? this.defaultSelect : this.orderZoneList.find(x => x.key === zone.key)
          })
        },
        getStatus (status = null) {
          this.orderStatusList.push(this.defaultSelect)
          return this.getOrderStatus().then((response) => {
            if (response === undefined) {
              if (status !== null) {
                this.orderStatusList.push(status)
              }
            } else {
              this.orderStatusList = this.orderStatusList.concat(response.statusList)
            }
            this.filter.Status = status === null ? this.defaultSelect : this.orderStatusList.find(x => x.key === status.key)
          })
        },
        getDePrDi (departament = null, province = null, district = null) {
          this.departamentList = []
          this.provinceList = [this.defaultUbigeo]
          this.districtList = [this.defaultUbigeo]

          this.departamentList.push(this.defaultUbigeo)
          return this.getUbigeo({ Code: '', Type: constants.ubigeoType.departament }).then((response) => {
            if (response === undefined) {
              if (departament !== null) {
                this.departamentList.push(departament)
              }
            } else {
              this.departamentList = this.departamentList.concat(response.ubigeoList)
            }
            this.filter.Department = departament === null ? this.defaultUbigeo : this.departamentList.find(x => x.code === departament.code)
            this.filter.Province = this.defaultUbigeo
            this.filter.District = this.defaultUbigeo

            if (departament !== null) {
              this.provinceList = []
              this.districtList = [this.defaultUbigeo]

              this.provinceList.push(this.defaultUbigeo)
              let depa = departament === null ? this.filter.Department.code : departament.code
              return this.getUbigeo({ Code: depa, Type: constants.ubigeoType.province }).then((response) => {
                if (response === undefined) {
                  if (province !== null) {
                    this.provinceList.push(province)
                  }
                } else {
                  this.provinceList = this.provinceList.concat(response.ubigeoList)
                }
                this.filter.Province = province === null ? this.defaultUbigeo : this.provinceList.find(x => x.code === province.code)
                this.filter.District = this.defaultUbigeo

                if (province !== null) {
                  this.districtList = []

                  this.districtList.push(this.defaultUbigeo)

                  let prov = province === null ? this.filter.Province.code : province.code
                  return this.getUbigeo({ Code: prov, Type: constants.ubigeoType.district }).then((response) => {
                    if (response === undefined) {
                      if (district !== null) {
                        this.districtList.push(district)
                      }
                    } else {
                      this.districtList = this.districtList.concat(response.ubigeoList)
                    }
                    this.filter.District = district === null ? this.defaultUbigeo : this.districtList.find(x => x.code === district.code)
                  })
                }
              })
            }
          })
        },
        getDepartament (departament = null) {
          this.departamentList = []
          this.provinceList = [this.defaultUbigeo]
          this.districtList = [this.defaultUbigeo]

          this.departamentList.push(this.defaultUbigeo)
          this.getUbigeo({ Code: '', Type: constants.ubigeoType.departament }).then((response) => {
            if (response === undefined) {
              if (departament !== null) {
                this.departamentList.push(departament)
              }
            } else {
              this.departamentList = this.departamentList.concat(response.ubigeoList)
            }
            this.filter.Department = departament === null ? this.defaultUbigeo : this.departamentList.find(x => x.code === departament.code)
            this.filter.Province = this.defaultUbigeo
            this.filter.District = this.defaultUbigeo
          })
        },
        getProvince (departament = null, province = null) {
          this.provinceList = []
          this.districtList = [this.defaultUbigeo]

          this.provinceList.push(this.defaultUbigeo)
          let depa = departament === null ? this.filter.Department.code : departament
          this.getUbigeo({ Code: depa, Type: constants.ubigeoType.province }).then((response) => {
            if (response === undefined) {
              if (province !== null) {
                this.provinceList.push(province)
              }
            } else {
              this.provinceList = this.provinceList.concat(response.ubigeoList)
            }
            this.filter.Province = province === null ? this.defaultUbigeo : this.provinceList.find(x => x.code === province.code)
            this.filter.District = this.defaultUbigeo
          })
        },
        getDistrict (province = null, district = null) {
          this.districtList = []

          this.districtList.push(this.defaultUbigeo)

          let prov = province === null ? this.filter.Province.code : province
          this.getUbigeo({ Code: prov, Type: constants.ubigeoType.district }).then((response) => {
            if (response === undefined) {
              if (district !== null) {
                this.districtList.push(district)
              }
            } else {
              this.districtList = this.districtList.concat(response.ubigeoList)
            }
            this.filter.District = district === null ? this.defaultUbigeo : this.districtList.find(x => x.code === district.code)
          })
        },
        reloadTypes () {
          if (this.orderTypeList.filter(x => x.key !== '').length === 1) {
            this.orderTypeList = []
            this.getTypes(this.filter.OrderType)
          }
        },
        reloadZone () {
          if (this.orderZoneList.filter(x => x.key !== '').length === 1) {
            this.orderZoneList = []
            this.getZones(this.filter.Zone)
          }
        },
        reloadStatus () {
          if (this.orderStatusList.filter(x => x.key !== '').length === 1) {
            this.orderStatusList = []
            this.getStatus(this.filter.Status)
          }
        },
        reloadDepartament () {
          if (this.departamentList.filter(x => x.code !== '').length === 1) {
            this.departamentList = []
            this.getDePrDi(this.filter.Department, this.filter.Province, this.filter.District)
          }
        },
        reloadProvince () {
          if (this.provinceList.filter(x => x.code !== '').length === 1) {
            this.provinceList = []
            this.getDePrDi(this.filter.Department, this.filter.Province, this.filter.District)
          }
        },
        reloadDistrict () {
          if (this.districtList.filter(x => x.code !== '').length === 1) {
            this.districtList = []
            this.getDePrDi(this.filter.Department, this.filter.Province, this.filter.District)
          }
        },
        search (page, isPaging = false, flag = true) {
          this.dateRange = null
          this.pageNumber = page

          this.filter.AccountCode = this.account.code
          this.filter.Page = this.pageNumber

          let filter = {}

          if (isPaging) {
            filter = {
              AccountCode: this.parameters.AccountCode,
              CustomerOrderNumber: this.parameters.CustomerOrderNumber,
              TrackingNumber: this.parameters.TrackingNumber,
              StartOrderDate: this.parameters.StartOrderDate,
              EndOrderDate: this.parameters.EndOrderDate,
              OrderTypeCode: this.parameters.OrderType == null ? '' : this.parameters.OrderType.key,
              ZoneCode: this.parameters.Zone == null ? '' : this.parameters.Zone.key,
              StatusCode: this.parameters.Status == null ? '' : this.parameters.Status.key,
              DepartmentCode: this.parameters.Department == null ? '' : this.parameters.Department.code,
              ProvinceCode: this.parameters.Province == null ? '' : this.parameters.Province.code,
              DistrictCode: this.parameters.District == null ? '' : this.parameters.District.code,
              Page: this.filter.Page,
              PageSize: this.filter.PageSize
            }
          } else {
            if (!this.showFilter && this.mobile) {
              this.filter.StartOrderDate = null
              this.filter.EndOrderDate = null
            } else {
              if ($('#dtDateRange').val() === '') {
                this.filter.StartOrderDate = null
                this.filter.EndOrderDate = null
              } else {
                this.filter.StartOrderDate = $(this.$el).find('#dtDateRange').data('daterangepicker').startDate.format('YYYY-MM-DD') + 'T00:00:00'
                this.filter.EndOrderDate = $(this.$el).find('#dtDateRange').data('daterangepicker').endDate.format('YYYY-MM-DD') + 'T00:00:00'
              }
            }

            filter = {
              AccountCode: this.filter.AccountCode,
              CustomerOrderNumber: this.filter.CustomerOrderNumber,
              TrackingNumber: this.filter.TrackingNumber,
              StartOrderDate: this.filter.StartOrderDate,
              EndOrderDate: this.filter.EndOrderDate,
              OrderTypeCode: this.filter.OrderType == null ? '' : this.filter.OrderType.key,
              ZoneCode: this.filter.Zone == null ? '' : this.filter.Zone.key,
              StatusCode: this.filter.Status == null ? '' : this.filter.Status.key,
              DepartmentCode: this.filter.Department == null ? '' : this.filter.Department.code,
              ProvinceCode: this.filter.Province == null ? '' : this.filter.Province.code,
              DistrictCode: this.filter.District == null ? '' : this.filter.District.code,
              Page: this.filter.Page,
              PageSize: this.filter.PageSize
            }
          }

          this.parameters = {
            AccountCode: this.filter.AccountCode,
            CustomerOrderNumber: this.filter.CustomerOrderNumber,
            TrackingNumber: this.filter.TrackingNumber,
            StartOrderDate: this.filter.StartOrderDate,
            EndOrderDate: this.filter.EndOrderDate,
            OrderType: this.filter.OrderType,
            Zone: this.filter.Zone,
            Status: this.filter.Status,
            Department: this.filter.Department,
            Province: this.filter.Province,
            District: this.filter.District,
            Page: this.filter.Page,
            PageSize: this.filter.PageSize
          }

          if (filter.StartOrderDate === null && filter.EndOrderDate === null && filter.CustomerOrderNumber === '' && filter.TrackingNumber === '') {
            this.message.title = 'Advertencia'
            this.message.description = 'Debe seleccionar un rango de Fecha Pedido o Nro pedido o Nro Tracking'
            this.message.type = 'warn'
            this.message.show = true
          } else {
            document.activeElement.blur()

            this.loader = this.$loading.show({
              loader: 'dots'
            })

            this.tableData = {
              data: null
            }

            this.getOrderFollow(filter).then((data) => {
              if (data != null) {
                if (flag) {
                  this.defualtFilter = false
                  this.selectIndex = -1
                }

                if (data.orderList != null) {
                  this.tableData = {
                    data: data.orderList
                  }
                  this.totalPages = {
                    data: data.pagination.totalItems,
                    total: data.pagination.totalPage,
                    size: data.pagination.limit
                  }
                }
                this.loader.hide()
                this.tableKey++
              }
            })
          }
        },
        showExport () {
          let mensaje = ''
          if (this.tableData.data === null || this.tableData.data.length === 0) {
            mensaje = 'La lista se encuentra vacia'
          } else if (this.parameters.StartOrderDate === null && this.parameters.EndOrderDate === null && this.parameters.CustomerOrderNumber === '' && this.parameters.TrackingNumber === '') {
            mensaje = 'Debe seleccionar un rango de Fecha Pedido o Nro pedido o Nro Tracking'
          }

          if (mensaje !== '') {
            this.message.title = 'Advertencia'
            this.message.description = mensaje
            this.message.type = 'warn'
            this.message.show = true
          } else {
            this.showModalExport = true
          }
        },
        closeExport () {
          this.fEmail = ''
          this.showModalExport = false
        },
        exportOrder () {
          let mensaje = ''
          if (this.tableData.data === null || this.tableData.data.length === 0) {
            mensaje = 'La lista se encuentra vacia'
          } else if (this.parameters.StartOrderDate === null && this.parameters.EndOrderDate === null && this.parameters.CustomerOrderNumber === '' && this.parameters.TrackingNumber === '') {
            mensaje = 'Debe seleccionar un rango de Fecha Pedido o Nro pedido o Nro Tracking'
          }

          if (mensaje !== '') {
            this.message.title = 'Advertencia'
            this.message.description = mensaje
            this.message.type = 'warn'
            this.message.show = true
          } else {
            document.activeElement.blur()

            this.submitted = true
            this.isEmail = this.validateEmail(this.fEmail)

            if (this.fEmail !== '' && this.isEmail) {
              let filter = {
                AccountCode: this.parameters.AccountCode,
                CustomerOrderNumber: this.parameters.CustomerOrderNumber,
                TrackingNumber: this.parameters.TrackingNumber,
                StartOrderDate: this.parameters.StartOrderDate,
                EndOrderDate: this.parameters.EndOrderDate,
                OrderTypeCode: this.parameters.OrderType == null ? '' : this.parameters.OrderType.key,
                ZoneCode: this.parameters.Zone == null ? '' : this.parameters.Zone.key,
                StatusCode: this.parameters.Status == null ? '' : this.parameters.Status.key,
                DepartmentCode: this.parameters.Department == null ? '' : this.parameters.Department.code,
                ProvinceCode: this.parameters.Province == null ? '' : this.parameters.Province.code,
                DistrictCode: this.parameters.District == null ? '' : this.parameters.District.code,
                EmailRecipient: this.fEmail
              }

              this.loader = this.$loading.show({
                loader: 'dots'
              })

              this.getOrderReport(filter).then((data) => {
                if (data != null) {
                  if (data.errorCode === 0) {
                    this.fEmail = ''
                    this.submitted = false
                    this.showModalExport = false

                    this.message.title = 'Información'
                    this.message.description = 'El Excel fue enviado con éxito a su correo'
                    this.message.type = 'info'
                    this.message.show = true
                  } else {
                    this.message.title = 'Error'
                    this.message.description = data.errorDescription
                    this.message.type = 'error'
                    this.message.show = true
                  }
                  this.loader.hide()
                }
              })
            }
          }
        },
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.paginationData = paginationData
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)

          if (page > 0) {
            this.pageNumber = page
          }
          if (page === 'next') {
            this.pageNumber += 1
            if (this.pageNumber >= this.totalPages.total) {
              this.pageNumber -= 1
              return
            }
          }
          if (page === 'prev') {
            this.pageNumber -= 1
            if (this.pageNumber < 1) {
              this.pageNumber += 1
              return
            }
          }
          this.search(this.pageNumber, true)
        },
        dataManager (sortOrder, pagination) {
          let data = []
          data = this.tableData.data
          if (this.tableData.data && this.totalPages.data > 1) {
            let total = 0
            if (this.totalPages.data % this.totalPages.size === 0) {
              total = parseInt(this.totalPages.data / this.totalPages.size, 10)
            } else {
              total = parseInt(this.totalPages.data / this.totalPages.size, 10) + 1
            }
            pagination = this.$refs.vuetable.makePagination(data.length)
            pagination.per_page = this.totalPages.size
            pagination.to = data.length
            pagination.last_page = total
            pagination.current_page = this.pageNumber
            pagination.total = this.totalPages.data
            pagination.next_page_url = pagination.current_page + 1
            if (pagination.next_page_url > 1) {
              pagination.prev_page_url = pagination.current_page - 1
            }
            data = data.slice(pagination.from - 1, pagination.to)
          } else {
            pagination = this.$refs.vuetable.makePagination(0)
          }
          return {
            pagination: pagination,
            data: data
          }
        },
        clear () {
          this.filter = {
            AccountCode: '',
            OrderNumber: '',
            TrackingNumber: '',
            CustomerOrderNumber: '',
            StartOrderDate: '',
            EndOrderDate: '',
            OrderType: this.defaultSelect,
            Zone: this.defaultSelect,
            Status: this.defaultSelect,
            Department: this.defaultUbigeo,
            Province: this.defaultUbigeo,
            District: this.defaultUbigeo,
            Page: 1,
            PageSize: 20
          }
          this.tableData = {
            data: null
          }

          this.dateRange = null
          this.parameters = null
          this.selectIndex = -1
          $('#dtDateRange').val('')
          this.iniCalendar()
          this.getDepartament()
        },
        handleResize () {
          this.window.width = window.innerWidth
          this.window.height = window.innerHeight
        },
        formatDate (value) {
          return moment(value).format('DD/MM/YYYY')
        },
        contact () {
          window.open(constants.defaultGeneral.urlHelp, '_blank')
        },
        iniCalendar () {
          $('#dtDateRange').daterangepicker({
            showDropdowns: true,
            locale: constants.datePickerLocale,
            maxDate: moment(),
            autoUpdateInput: false,
            applyClass: 'btn-apply-ora',
            cancelClass: 'btn-cancel-ora',
            autoApply: false
          }, function (start, end, label) {
            $('#dtDateRange').val(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'))
          })

          $('#dtDateRange').on('apply.daterangepicker', function (ev, picker) {
            $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'))
          })

          $('.daterangepicker').addClass('daterangepicker-ora')
        },
        verFiltros () {
          this.showFilter = !this.showFilter
          let self = this
          setTimeout(function () { self.iniCalendar() }, 1000)
        },
        hiddenTrack (value) {
          this.showTrack = value
          let self = this
          setTimeout(function () {
            self.iniCalendar()
            if (self.parameters.StartOrderDate !== null || self.parameters.EndOrderDate !== null) {
              if (self.dateRange !== null) {
                $(self.$el).find('#dtDateRange').data('daterangepicker').startDate = self.dateRange.startDate
                $(self.$el).find('#dtDateRange').data('daterangepicker').endDate = self.dateRange.endDate
                $('#dtDateRange').val(self.dateRange.startDate.format('DD/MM/YYYY') + ' - ' + self.dateRange.endDate.format('DD/MM/YYYY'))
              }
            }

            $(window).scrollTop(self.parameters.ScrollY)
            self.selectIndex = self.parameters.Index
          }, 1000)
        },
        goTracking (order, index) {
          this.tracking = order.trackingNumber
          this.firstName = order.customerName
          this.orderNumber = order.customerOrderNumber
          this.showTrack = true
          this.showBack = true
          this.parameters.Index = index
          this.parameters.ScrollY = window.scrollY
          this.dateRange = $(this.$el).find('#dtDateRange').data('daterangepicker')
        },
        optDescription ({ key, description }) {
          return this.$options.filters.firstLetter(description)
        },
        optName ({ code, name }) {
          return this.$options.filters.firstLetter(name)
        },
        showAdvanced () {
          this.advanced = !this.advanced
          if (!this.advanced && !this.defualtFilter) {
            this.filter.TrackingNumber = ''
            this.filter.Status = this.defaultSelect
            this.getDepartament()
          }
        },
        validateEmail (email) {
          if ((/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/).test(email)) {
            return true
          } else {
            return false
          }
        }
      },
      components:
      {
        Tracking: () => import('./TrackingNumber.vue'),
        Multiselect,
        Vuetable,
        'vuetable-pagination': VuetablePagination
      },
      filters: {
        capitalize: function (value) {
          if (!value) return ''
          return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1)
        },
        firstLetter: function (value) {
          if (!value) return ''
          var pieces = value.toString().toLowerCase().split(' ')
          for (var i = 0; i < pieces.length; i++) {
            var j = pieces[i].charAt(0).toUpperCase()
            pieces[i] = j + pieces[i].substr(1)
          }
          return pieces.join(' ')
        },
        minus: function (value) {
          if (!value) return ''
          return value.toString().toLowerCase()
        }
      }
    }
  </script>
  <style>
    
    @font-face {
      font-family: "Poppins";
      font-weight: 400;
      font-style: normal;
      font-display: auto;
      unicode-range: U+000-5FF;
      src: local("Roboto"), url("/static/Fonts/Poppins/Poppins-Regular.ttf") format("truetype");
    }

    .wrapper
    {
      position: unset !important;
      background-color:rgb(246, 246, 246) !important;
    }    
  
    .nav-order
    {
      padding:25px 16px !important;      
      display : flex;
      align-items : center;
      justify-content : space-between;      
    }

    .container-tra {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #f9f6f6;
      top: 0;
      left: 0;
      font-family : "Poppins"
    }    

    .ati-flex
    {
      display:flex;
      align-items: center;
      justify-content: space-between;
    }

    .ati-pb
    {
      padding-bottom:15px
    }

    .nav-header-title-label
    {
      font-weight: 500 !important;
      font-size: 18px;
      line-height: 24px;
      color: #415684;
      padding-left: 5px;
    }

    .title-filter
    {
      background: rgba(61, 119, 255, 0.1);
      padding: 8px;
      border-radius: 4px;
      margin-left: 5px;
    }

    .label-filter
    {
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      color: #0C204E;   
      padding-left: 5px;   
    }
    
    .doc-filter
    {
      background-color: white;
      padding: 15px;
      margin: 15px;
      border-radius: 8px;
    }

    .input-group-ora
    {
      border: 1px solid #D8D8D8;
      border-radius: 8px !important;
      display: flex;
      align-items: center;      
    }

    .input-group-ora:hover
    {
      border: 1px solid #FF833E;    
    }   

    .form-control-ora
    {
      height: 36px !important;
      border-radius: 8px !important;
    }
         
    .form-control-ora:hover
    {
      border: 1px solid #FF833E;    
    }

    .input-group-addon-ico    
    {
      height: 36px !important;
      border: 0px !important; 
      border-radius:8px !important;  
      display: flex;
      align-items: center;
      color: #3355A4;
      font-weight:900;
      font-size: 16px;
      width: 30px;      
    }

    .form-control-ora-sin
    {
      height: 36px !important;
      border: 0px !important;
      border-radius:8px !important; 
      background-color:transparent !important;
    } 
    
    .form-control-ora-sin-blank
    {
      height: 36px !important;
      border: 0px !important;
      border-radius:8px !important; 
      background-color:#ffffff !important;
    }     
  
    .form-control-ora-sin::placeholder{
      font-weight:bold;
    }

    .form-control-ora-sin-blank::placeholder{
      font-weight:bold;
    }    

    .form-control-ora-sin:invalid{
      font-weight:bold;
      color: #959595;
    }

    .form-control-ora-sin-blank:invalid{
      font-weight:bold;
      color: #959595;
    }

    .form-control-ora-sin-select {
      background-image: url(/static/img/svg/arrow.svg);
      background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 10px), calc(100% - 2.5em) 0.5em;
      background-size: 11px;
      background-repeat: no-repeat;
      transition: .1s;
    }  
    
    select {
      background-image: url(/static/img/svg/arrow-black.svg);
      background-position: calc(100% - 5px) calc(1em - 5px), calc(100% - 15px) calc(1em + 10px), calc(100% - 2.5em) 0.5em;      
      background-size: 11px;
      background-repeat: no-repeat;
      transition: .1s;   
    }

    .daterangepicker .input-mini
    {
      height:36px !important;
    }

    .btn-ora
    {
      height: 36px;
      color:#ffffff;
      background-color: #FF833E;
      width:100%;
      border-radius: 8px;
    }

    .btn-apply-ora
    {
      height: 36px;
      color:#ffffff;
      background-color: #FF833E;
      border-radius: 8px;
    }  
    
    .btn-cancel-ora
    {
      height: 36px;
      color:#444;
      background-color: #f4f4f4;
      border-radius: 8px;
    }    

    .btn-ora-auto
    {
      width: auto;      
    } 
    
    .btn-ora-radius
    {
      border-radius: 16px;
      display: inline-flex;
      height: 24px;
      align-items: center;
      width: auto;      
    }     
  
    .btn-ora:hover
    {
      background-color: #fb5d05;
      color:#ffffff;
    } 
    
    .btn-ora:active
    {
      background-color: #fb5d05;
      color:#ffffff !important;
    }   
  
    .table-text-ora {
      vertical-align: middle !important;
      text-transform: none !important;
      color: #0C204E !important;
      font-family: "Poppins" !important;
      padding: 5px 16px !important;
      border-bottom: 2px solid #e8e8e8 !important;
    }

    .table-data-ora {
      vertical-align: middle !important;
      text-transform: none !important;
      color:  #879BAB !important;
      font-family: "Poppins" !important;
      padding: 10px 16px !important;
      vertical-align:middle;
    }    

    table.tr-ora tr:nth-child(odd) td{
      background:#ffffff !important;
      border: 0px !important;
      
    }
    table.tr-ora tr:nth-child(even) td{
      background:#FAFBFF !important;
      border: 0px !important;
    }    
    .data-type
    {
      filter: brightness(0) saturate(100%) invert(57%) sepia(82%) saturate(5584%) hue-rotate(211deg) brightness(102%) contrast(101%);
    }

    .data-type-orange
    {      
      filter: brightness(0) saturate(100%) invert(43%) sepia(100%) saturate(1269%) hue-rotate(0deg) brightness(102%) contrast(105%);
    }

    .data-arrow
    {
      padding-right: 20px;  
      color: #b5b3b3;
      cursor:pointer;
    }

    .data-status-ora
    {
      background: #F3F6FF;
      border-radius: 200px;
      font-size: 12px;
      padding: 4px 8px;
      color: #3D77FF;
      text-align: center;  
      min-width: 90px;
      max-width: 150px;
    }

    .ico-seach-input
    {
      filter: brightness(0) saturate(100%) invert(28%) sepia(27%) saturate(3577%) hue-rotate(205deg) brightness(89%) contrast(86%);
      width:16px;
    }

    .div-filtro
    {
      background: #ffffff;
      padding: 20px 0px;
      border-radius: 8px;
    }

    .div-data
    {
      background: white;
      border-radius: 16px;
      padding: 10px;
      border: 1px solid #DBDFE3;
      margin-bottom: 10px;
    }

    .div-data-space
    {
      padding-left: 15px;
      padding-right: 5px;      
    }

    .div-data-bottom
    {
      margin-bottom: 10px;   
    }    

    .div-data-title
    {
      font-size: 12px;
      color: #879BAB;
      font-weight: 100;
      margin-bottom: 0px;
    }

    .div-data-value
    {
      color: #0C204E;
      font-weight: 600;  
      margin-bottom: 0px;    
    }

    .div-data-value-limit
    {
      color: #0C204E;
      font-weight: 600;
      margin-bottom: 0px;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .div-data-status
    {
      color: #3D77FF;       
      margin-bottom: 0px;    
    }

    .div-data-ico
    {
      margin-left: -35px;
      padding-top: 70px;
      position: absolute;
    }

    .div-data-ico-circle
    {
      background: white;
      border-radius: 50%;
      border: 1px solid #DBDFE3;
      padding: 4px;      
    }
    
    .div-data-ico-img
    {
      width: 32px;
      padding: 4px;     
    }  

    .multiselect-ora {
      min-height: 36px;
      margin-left: -30px;
      position: initial;
    }

    .multiselect-ora .multiselect__tags
    {
      height: 36px !important;
      min-height: 36px !important;
      border: 0px !important;
      border-radius: 8px !important;
      font-size: 13px;    
      font-weight: bold;     
    }

    .multiselect-ora .multiselect__select
    {
      background-image: url('/static/img/svg/arrow.svg') !important;
      background-position: center!important;
      background-size: 11px !important;
      background-repeat: no-repeat !important;
      transition: transform .2s ease !important;      
      width: 30px !important;
      height:25px !important;
      padding: 0px !important;
      background-color: white !important;
    z-index: 1 !important;     
    }    

    .multiselect-ora .multiselect__select:before
    {
      content: '' !important;
      border-style: hidden !important;
      
    } 
    
    .multiselect-ora .multiselect__option--highlight
    {
      background-color:#FF833E !important; 
    }

    .multiselect-ora .multiselect__placeholder
    {
      color: #959595 !important;
      padding-left: 35px;
    }

    .multiselect-ora .multiselect__single
    {      
      padding-left: 35px;
      background-color: transparent !important;
      font-weight:normal;
      font-size:13px;
      margin-top: -2px;
      white-space: pre;
      overflow: hidden;
    }  
    
    .multiselect-ora .multiselect__element
    {    
      font-size: 13px;
    }

    .multiselect-ora .multiselect__content-wrapper
    {
      margin-top: 2px;
      border-radius: 8px;
      border: 1px solid #FF833E;
    }

    .multiselect-ora .multiselect__input
    {
      font-size:13px;
    }
      
    .multiselect-ora-layer .multiselect__input::placeholder{
      color:#9B9A9A;
      padding-left:30px;      
      background-color:transparent !important;
      background-image:url('/static/img/svg/layers.svg');
      background-repeat: no-repeat;
    }

    .multiselect-ora-point .multiselect__input::placeholder{
      color:#9B9A9A;
      padding-left:30px;      
      background-color:transparent !important;
      background-image:url('/static/img/svg/zone.svg');
      background-repeat: no-repeat;
    }    

    .multiselect-ora-bar .multiselect__input::placeholder{
      color:#9B9A9A;
      padding-left:30px;      
      background-color:transparent !important;
      background-image:url('/static/img/svg/bar.svg');
      background-repeat: no-repeat;
    }  
    
    .label-ora {      
      position: absolute;
      top: 5px;
      bottom: 0;
      left: 10px;
      display: flex;
      align-items: center;
      pointer-events: none;
      font-size:12px;      
    }

    .label-ora {      
      position: absolute;
      top: 5px;
      bottom: 0;
      left: 10px;
      display: flex;
      align-items: center;
      pointer-events: none;
      font-size:12px;
      background-color:transparent;
    }    
    
    .label-ora .text-ora {
      transition: all 0.15s ease-out;
      color: #9B9A9A;
    }

    input:focus + .label-ora .text-ora, :not(input[value=""]) + .label-ora .text-ora {      
      font-size: 10px;
      transform: translate(0, -150%);
      background-color: white;
      padding-left: 4px;
      padding-right: 4px;      
    }

    input:focus + .label-ora .text-ora {
      color: #FF833E;
      left: 16px !important;
    } 

    .multiselect__input:focus + .label-ora .text-ora, :not(input[value=""]) + .label-ora .text-ora {
      font-size: 10px;
      transform: translate(0, -150%);
      background-color: white;
      padding-left: 4px;
      padding-right: 4px;       
    }    
    
    .multiselect__input:focus + .label-ora .text-ora {
      color: #FF833E;
      left: 16px !important;
    }  

    .daterangepicker-ora td.active{
      background-color:#FF833E !important;
    }

    .daterangepicker-ora td.in-range
    {
      background-color:#FCE4D9;
    }

    .daterangepicker-ora .input-mini.active
    {
      border: 1px solid #FF833E !important;
    }

    .modal-cus-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: table;
      transition: opacity 0.3s ease;
    }

    .modal-cus-wrapper {
      display: table-cell;
      vertical-align: middle;
    }

    .modal-cus-container {
      width: 80%;    
      margin: 0px auto;
      padding: 10px 15px;
      background-color: #fff;
      border-radius: 16px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
      transition: all 0.3s ease;
      font-family: Helvetica, Arial, sans-serif;
    }

    .modal-cus-header h3 {
      margin-top: 0;
      color: #42b983;
    }

    .modal-cus-body {
      margin: 5px 0;
      text-align: center;
    }

    .modal-cus-default-button {
      float: right;
    }

    .modal-cus-enter {
      opacity: 0;
    }

    .modal-cus-leave-active {
      opacity: 0;
    }

    .modal-cus-enter .modal-cus-container,
    .modal-cus-leave-active .modal-cus-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }   
    
    .selected-row {      
      color:#FF833E;
      font-weight: 900;
    }

    .selected-row-mov {      
      border: 1px solid #FF833E !important;
    }    

    .selected-row>img {      
      filter: brightness(0) saturate(100%) invert(61%) sepia(70%) saturate(1221%) hue-rotate(330deg) brightness(99%) contrast(106%);
    } 
    
    .selected-row>a {      
      color:#FF833E;      
    } 
    
    .msg-info{
      font-size: 24px;
      color: #71CB84;
    }

    .msg-warn{
      font-size: 24px;
      color: #f3b543;
    }  
    
    .msg-error{
      font-size: 24px;
      color: #ef390e
    }      

    .btn-ora-msg {
        height: 24px;
        font-size: 12px;
        color: #ffffff;
        background-color: #5088F8;
        padding: 3px 10px;        
        border-radius: 16px;
    }    

    .btn-ora-msg-info {
      background-color: #71CB84;
    }
    
    .btn-ora-msg-warn {
      background-color: #f3b543;
    }
    
    .btn-ora-msg-error {
      background-color: #ef390e;
    }     

    @media screen and (max-width: 414px) {
      .row {
        margin-right: 0px !important;
      } 
      
      input:focus + .label-ora .text-ora {
        background-color:rgb(246, 246, 246);
      }

      .modal-cus-container {
        width: 95% !important;
      }     
    }
    
    @media screen and (max-width: 320px) {
      .row {
        margin-right: 0px !important;
      } 
      
      .modal-cus-container {
        width: 98% !important;
      }        
    }
  
  </style>



// WEBPACK FOOTER //
// OrderSearch.vue?675d4593